'use strict';

angular.module('amexReconciliationApp')
  .component('lineItemIcon', {
    templateUrl: 'scripts/views/components/line-item-icon.html',
    bindings: {
      transaction: '<',
      showText: '<'
    },
    controller: function ($scope, $uibModal) {
      var self = this;

      self.openFullLineItem = function openFullLineItem() {
        var scopeWithTransaction = $scope.$new();
        scopeWithTransaction.transaction = self.transaction;
        $uibModal.open({
          template: '<line-item-details-modal transaction="transaction" close-modal-callback="$close()"></line-item-details-modal>',
          size: 'xlg',
          scope: scopeWithTransaction
        });
      };
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/lineItemIcon.js
// module id = 455
// module chunks = 0